import { Business, PartnerStatistics, CommissionPlan, User } from '@/classes/models'

export default class Partner {
  /**
   * Create new partner and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map businesses to Business if there are businesses
    this.businesses = typeof this.businesses !== 'undefined' ? this.businesses.map(business => new Business(business)) : []

    // Map commission plans to CommissionPlans if there are commission  plans
    this.commissionPlans = typeof this.commissionPlans !== 'undefined' ? this.commissionPlans.map(commissionPlan => new CommissionPlan(commissionPlan)) : []

    // Map statistcis to PartnerStatistics if there are statistics
    this.statistics = typeof this.statistics !== 'undefined' ? this.statistics.map(statistics => new PartnerStatistics(statistics)) : []

    // Map users to User if there are users
    this.users = typeof this.users !== 'undefined' ? this.users.map(user => new User(user)) : []
  }
}
